import moment from 'moment';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
export var trackLatexDownloadMenuOpened = function trackLatexDownloadMenuOpened(document) {
  var _document$file$identi, _document$file, _document$file$name, _document$file2;
  var seconds = moment().diff(moment(document.createdAt), 'seconds');
  var duration = moment.duration(seconds, 'seconds');
  trackRubriqEvent('LaTeX Download Menu Opened', {
    document_type: 'tex',
    file_identity: (_document$file$identi = (_document$file = document.file) === null || _document$file === void 0 ? void 0 : _document$file.identity) !== null && _document$file$identi !== void 0 ? _document$file$identi : null,
    file_name: (_document$file$name = (_document$file2 = document.file) === null || _document$file2 === void 0 ? void 0 : _document$file2.name) !== null && _document$file$name !== void 0 ? _document$file$name : null,
    time_after_completion: "".concat(Math.floor(duration.asMinutes()), " min ").concat(duration.seconds(), " sec")
  });
};
export var trackUseRubriqInWordClicked = function trackUseRubriqInWordClicked() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$userAddinStatus = _ref.userAddinStatus,
    userAddinStatus = _ref$userAddinStatus === void 0 ? 'unknown' : _ref$userAddinStatus,
    _ref$planName = _ref.planName,
    planName = _ref$planName === void 0 ? 'unknown' : _ref$planName,
    _ref$billingCycle = _ref.billingCycle,
    billingCycle = _ref$billingCycle === void 0 ? 'unknown' : _ref$billingCycle,
    _ref$hasActivePlan = _ref.hasActivePlan,
    hasActivePlan = _ref$hasActivePlan === void 0 ? 'unknown' : _ref$hasActivePlan,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'unknown' : _ref$label;
  trackRubriqEvent('Use Rubriq in Word Clicked', {
    user_addin_status: userAddinStatus,
    planName: planName,
    billing_cycle: billingCycle,
    has_active_plan: hasActivePlan,
    label: label
  });
};
export var trackGetRubriqAddinClicked = function trackGetRubriqAddinClicked() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$userAddinStatus = _ref2.userAddinStatus,
    userAddinStatus = _ref2$userAddinStatus === void 0 ? null : _ref2$userAddinStatus,
    _ref2$planName = _ref2.planName,
    planName = _ref2$planName === void 0 ? null : _ref2$planName,
    _ref2$billingCycle = _ref2.billingCycle,
    billingCycle = _ref2$billingCycle === void 0 ? null : _ref2$billingCycle,
    _ref2$hasActivePlan = _ref2.hasActivePlan,
    hasActivePlan = _ref2$hasActivePlan === void 0 ? null : _ref2$hasActivePlan;
  trackRubriqEvent('Get Rubriq Add-in Clicked', {
    user_addin_status: userAddinStatus,
    planName: planName,
    billing_cycle: billingCycle,
    has_active_plan: hasActivePlan
  });
};
export default trackLatexDownloadMenuOpened;